import { config } from "@/config/index";
import type { FirebaseApp } from "firebase/app";
import { initializeApp } from "firebase/app";
import type { Firestore } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import type { ReactNode } from "react";
import { createContext, useContext } from "react";

interface FirebaseContextType {
  app: FirebaseApp;
  firestore: Firestore;
}

const FirebaseContext = createContext<FirebaseContextType | undefined>(undefined);

export const FirebaseProvider = ({ children }: { children: ReactNode }) => {
  const app = initializeApp(config.firebase);
  const firestore = getFirestore(app);

  return <FirebaseContext.Provider value={{ app, firestore }}>{children}</FirebaseContext.Provider>;
};

export const useFirestore = () => {
  const context = useContext(FirebaseContext);
  if (!context) {
    throw new Error("useFirestore must be used within FirebaseProvider");
  }
  return context.firestore;
};
